__webpack_require__.p = "https://assets-01.periodica.press/f0d35f8-20592777313/";